import React from 'react'; 
import {
    useStyles,
    ContactInfo
} from './style';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';

export const TablePdfAddressPaymentInfo = (props:any) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
     

    const classes = useStyles();

    return (
        <div>
            <Table>
                <TableRow>
                    <TableCell style={{borderBottom: 'none'}}>
                        <div className={classes.address}>
                        <ContactInfo>
                            <div>
                                <div>
                                    {`${language[homeState.default_language]["address"]}: ${props.props.purchase.address}`}
                                    <br></br>
                                    {` ${language[homeState.default_language]["receives"]}: ${props.props.purchase.contactName}`}
                                    <br></br>
                                    {`${language[homeState.default_language]["phone"]}: ${props.props.purchase.contactPhone}`}
                                    <br></br>
                                    {`${language[homeState.default_language]["email"]}: ${props.props.purchase.contactEmail}`}
                                </div>
                            </div>
                        </ContactInfo>
                        </div>
                    </TableCell>
                </TableRow>
            </Table>
        </div>
    )
}